export default "__VITE_ASSET__Df19XyiT__"